import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
  CardTitle,
  CardText,
} from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch, shallowEqual } from "react-redux";

import { withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";

import avatar from "../../assets/images/users/avatar-1.png";
// actions
import { editProfile, loginPasswordChange, resetProfileFlag, updateProfile, updateProfileImage } from "../../store/actions";
import PasswordStrengthMeter from "constants/PasswordStrengthMeter";
import edit from "./../../assets/images/svg/edit.svg"
import toast from "react-hot-toast";
import PageLoader from "components/Common/PageLoader";
import AuthLoader from "components/Common/AuthLoader";
const UserProfile = () => {

  //meta title
  document.title = "Profile | Glottis Logistics";

  const dispatch = useDispatch();

  const [email, setemail] = useState("");
  const [firstname, setfirstname] = useState("");
  const [lastname, setlastname] = useState("");
  const [phno, setphno] = useState("");
  const [idx, setidx] = useState('');
  const [id, setId] = useState('');
  const [passwordValidate, setPasswordValidate] = useState('')
  const [oldPasswordEye, setOldPasswordEye] = useState(false)
  const [newPasswordEye, setNewPasswordEye] = useState(false)
  const [confirmPasswordEye, setConfirmPasswordEye] = useState(false)
  const [avather, setavather] = useState(null)
  const [resetInput, setResetInput] = useState(false)
  const [settingsData, setSettingsData] = useState([])

  const { error, success } = useSelector(state => ({
    error: state.Profile.error,
    success: state.Profile.success,
  }), shallowEqual);
  const { roles } = useSelector(state => ({
    roles: state.GetAdminRoles.roles,
  }), shallowEqual)
  const { profileImgLoader, updateProfileState, updatePass } = useSelector(state => ({
    profileImgLoader: state.UpdateProfileImg.loading,
    updateProfileState: state.UpdateProfile,
    updatePass: state.LoginPasswordChange,
  }), shallowEqual)
  const settings = useSelector(state => ({
    settings: state.GetSettings.data
  }), shallowEqual)
  const obj = JSON.parse(localStorage.getItem("authUser"));
  useEffect(() => {
    if (obj) {
      setfirstname(obj.user.firstName);
      setlastname(obj.user.lastName);
      setphno(obj.user.phoneNumber);
      setemail(obj.user.email);
      setidx(obj.user.role);
      setId(obj.user._id);
      setavather(obj.user.profileImg);
      setTimeout(() => {
        dispatch(resetProfileFlag());
      }, 3000);
    }
  }, [obj.user.firstName, obj.user.lastName, obj.user.phoneNumber, obj.user.email, obj.user._id, obj.user.role, obj.user.profileImg]);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      firstName: firstname || '',
      lastName: lastname || '',
      phoneNumber: phno || '',
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("Enter a first name").max(30, 'First name should not exceed 30 characters'),
      lastName: Yup.string().required("Enter a last name").max(30, 'Last name should not exceed 30 characters'),
      phoneNumber: Yup.string().required("Enter a phone number").max(15, 'Phone number should not exceed 15 characters'),
    }),
    onSubmit: (values) => {
      dispatch(updateProfile(values, history, id));
    }
  });
  const passwordForm = useFormik({
    enableReinitialize: true,

    initialValues: {
      oldPassword: '',
      newPassword: '',
      ConfirmPassword: '',
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string().required("Enter a old password"),
      newPassword: Yup.string().notOneOf([Yup.ref('oldPassword'), null], 'Old password and new password must not be same').required("Enter a new password").test("newPassword_length", "Password should reach atleast medium strength", val => passwordValidate >= 2),
      ConfirmPassword: Yup.string().oneOf([Yup.ref('newPassword'), null], 'New password and confirm password must be same').required("Enter a Confirm password"),
    }),
    onSubmit: (values) => {
      const data = {}
      data["oldPassword"] = values.oldPassword
      data["password"] = values.newPassword
      data["userId"] = id
      dispatch(loginPasswordChange(data, history));
      passwordForm.resetForm()
    }
  });

  const [password, setPassword] = useState('')
  useEffect(() => {
    if (passwordForm.values?.newPassword) setPassword(passwordForm.values.newPassword)
  }, [passwordForm.values.newPassword])

  setTimeout(() => {
    if (resetInput === true) setResetInput(false)
  }, 0);
  useEffect(() => {
    if (settings?.settings) {
      if (settings?.settings?.data) {
        setSettingsData(settings?.settings?.data[0])
      } else {
        setSettingsData([])
      }
    }
  }, [settings])
  return (
    <React.Fragment>
      <div className="page-content profile-screen">
        <Container fluid>
          <Breadcrumb title="Dashboard" dashurl="/dashboard" breadcrumbItem="Profile" />
          {profileImgLoader ? <PageLoader /> : ""}

          <Card color="info" className="text-white-50">
            <CardBody>
              <CardTitle className="m-0 text-white">
                <i className="mdi mdi-alert-circle-outline me-3" />Please contact Glottis support team at <a className="text-white text-decoration-underline" href={`tel:${settingsData?.phoneNumber}`}>{settingsData?.phoneNumber}</a> or <a className="text-white text-decoration-underline" href={`mailto:${settingsData?.email}`}>{settingsData?.email}</a> to update your email address
              </CardTitle>
            </CardBody>
          </Card>

          <Row>
            <Col lg="12">
              {error && error ? <Alert color="danger">{error}</Alert> : null}
              {success ? <Alert color="success">{success}</Alert> : null}

              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="mx-3">
                      <div className="profile-edit">
                        <img src={!avather ? avatar : avather} alt="avatar" className="avatar-md rounded-circle img-thumbnail" />
                        {/* Do not remove this lines */}
                        {/* {resetInput == false ? <input type="file" id="profileUpload" accept="image/jpg,image/jpeg,image/png" name="profileUpload" hidden onChange={(e) => {
                          if (e.target.files && e.target.files.length > 0) {
                            const size = e.target.files[0].size / 1024 / 1024;
                            if (size < 1) {
                              if (e.target.files[0].type === 'image/jpeg' || e.target.files[0].type === 'image/jpg' || e.target.files[0].type === 'image/png') {
                                const data = e.target.files[0];
                                var reader = new FileReader();
                                reader.readAsDataURL(data);
                                reader.onload = function () {
                                  dispatch(updateProfileImage(reader.result))
                                };
                              } else {
                                toast.error("Supported file formats are PNG or JPEG")
                                setResetInput(true)
                              }
                            } else {
                              toast.error("Max allowed file size is 1 MB")
                              setResetInput(true)
                            }
                          }
                        }} /> : ""}
                        <label htmlFor="profileUpload" className="m-0 edit-icon">
                          <img src={edit} alt="Edit profile" />
                        </label> */}
                      </div>
                    </div>
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <h5 className="fw-600 mb-0">{firstname}</h5>
                        <p className="mb-1">{email}</p>
                        <p className="mb-0"> {roles?.map((role) => (
                          (idx === role.value) && role.label
                        ))}</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row className="justify-content-between mb-4 user-info">
            <Col lg="6">
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Update profile</h4>
                  <Form
                    className="form-horizontal"
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <div className="form-group mb-4">
                      <Label className="form-label">First name</Label>
                      <Input
                        name="firstName"
                        className="form-control"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.firstName || ""}
                        invalid={
                          validation.touched.firstName && validation.errors.firstName ? true : false
                        }
                      />
                      {validation.touched.firstName && validation.errors.firstName ? (
                        <FormFeedback type="invalid">{validation.errors.firstName}</FormFeedback>
                      ) : null}
                    </div>
                    <div className="form-group mb-4">
                      <Label className="form-label">Last name</Label>
                      <Input
                        name="lastName"
                        className="form-control"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.lastName || ""}
                        invalid={
                          validation.touched.lastName && validation.errors.lastName ? true : false
                        }
                      />
                      {validation.touched.lastName && validation.errors.lastName ? (
                        <FormFeedback type="invalid">{validation.errors.lastName}</FormFeedback>
                      ) : null}
                    </div>
                    <div className="form-group mb-4">
                      <Label className="form-label">Phone number</Label>
                      <Input
                        name="phoneNumber"
                        className="form-control"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.phoneNumber || ""}
                        invalid={
                          validation.touched.phoneNumber && validation.errors.phoneNumber ? true : false
                        }
                      />
                      {validation.touched.phoneNumber && validation.errors.phoneNumber ? (
                        <FormFeedback type="invalid">{validation.errors.phoneNumber}</FormFeedback>
                      ) : null}
                    </div>
                    <div className="text-center mt-4 d-flex justify-content-center">
                      {updateProfileState.loading === true ? <div className="action-btn-loader"><AuthLoader /></div> :
                        <Button type="submit" className="primary-button">
                          Save
                        </Button>}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>

            <Col lg="6" className="pwd-change">
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Change password</h4>
                  <Form
                    className="form-horizontal"
                    onSubmit={(e) => {
                      e.preventDefault();
                      passwordForm.handleSubmit();
                      return false;
                    }}
                  >
                    <div className="form-group mb-4 passwordChange-fields">
                      <Label className="form-label">Old password <span onClick={() => setOldPasswordEye(prevState => !prevState)}>{oldPasswordEye ? <i className="mdi mdi-eye-outline font-size-16"></i> : <i className="mdi mdi-eye-off-outline font-size-16"></i>}</span></Label>
                      <Input
                        name="oldPassword"
                        className="form-control"
                        type={oldPasswordEye ? 'text' : "password"}
                        onChange={passwordForm.handleChange}
                        onBlur={passwordForm.handleBlur}
                        value={passwordForm.values.oldPassword || ""}
                        invalid={
                          passwordForm.touched.oldPassword && passwordForm.errors.oldPassword ? true : false
                        }
                      />
                      {passwordForm.touched.oldPassword && passwordForm.errors.oldPassword ? (
                        <FormFeedback type="invalid">{passwordForm.errors.oldPassword}</FormFeedback>
                      ) : null}
                    </div>
                    <div className="form-group mb-4 passwordChange-fields">
                      <Label className="form-label">New password <span onClick={() => setNewPasswordEye(prevState => !prevState)}>{newPasswordEye ? <i className="mdi mdi-eye-outline font-size-16"></i> : <i className="mdi mdi-eye-off-outline font-size-16"></i>}</span></Label>
                      <Input
                        name="newPassword"
                        className="form-control"
                        type={newPasswordEye ? 'text' : "password"}
                        onChange={passwordForm.handleChange}
                        onBlur={passwordForm.handleBlur}
                        value={passwordForm.values.newPassword || ""}
                        invalid={
                          passwordForm.touched.newPassword && passwordForm.errors.newPassword ? true : false
                        }
                      />
                      <PasswordStrengthMeter password={password} setPasswordValidate={setPasswordValidate} />
                      {passwordForm.touched.newPassword && passwordForm.errors.newPassword ? (
                        <FormFeedback type="invalid">{passwordForm.errors.newPassword}</FormFeedback>
                      ) : null}
                    </div>
                    <div className="form-group mb-4 passwordChange-fields">
                      <Label className="form-label">Confirm password <span onClick={() => setConfirmPasswordEye(prevState => !prevState)}>{confirmPasswordEye ? <i className="mdi mdi-eye-outline font-size-16"></i> : <i className="mdi mdi-eye-off-outline font-size-16"></i>}</span> </Label>
                      <Input
                        name="ConfirmPassword"
                        className="form-control"
                        type={confirmPasswordEye ? 'text' : "password"}
                        onChange={passwordForm.handleChange}
                        onBlur={passwordForm.handleBlur}
                        value={passwordForm.values.ConfirmPassword || ""}
                        invalid={
                          passwordForm.touched.ConfirmPassword && passwordForm.errors.ConfirmPassword ? true : false
                        }
                      />
                      {passwordForm.touched.ConfirmPassword && passwordForm.errors.ConfirmPassword ? (
                        <FormFeedback type="invalid">{passwordForm.errors.ConfirmPassword}</FormFeedback>
                      ) : null}
                    </div>
                    <div className="text-center mt-4 d-flex justify-content-center">
                      {updatePass.loading === true ? <div className="action-btn-loader"><AuthLoader /></div> :
                        <Button type="submit" className="primary-button">
                          Change password
                        </Button>}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(UserProfile);
